{
  "EMOJI": {
    "PLACEHOLDER": "이모지 검색",
    "NOT_FOUND": "검색과 일치하는 이모지가 없습니다",
    "REMOVE": "제거"
  }
}
